module.exports = __webpack_public_path__ + "img/PE.b78897a4.png";